import getDevServerDefault from "react-native/Libraries/Core/Devtools/getDevServer";
var _getDevServerDefault_default;
var getDevServer = typeof getDevServerDefault === "function" ? getDevServerDefault : (_getDevServerDefault_default = getDevServerDefault.default) !== null && _getDevServerDefault_default !== void 0 ? _getDevServerDefault_default : getDevServerDefault;
export {
  getDevServer
};
//# sourceMappingURL=getDevServer.native.js.map
